module.exports = __webpack_public_path__ + "static/media/libcom-icon.5fb4ab85.svg";